<template>
  <v-card class="add-coupon-group" height="300px">
    <v-card-title>{{ $t('admin_acc_coupon_group.add_title') }}</v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-form ref="form">
          <v-text-field outlined
                        :label="$t('admin_acc_coupon_group.name')"
                        v-model="name"
                        :rules="requiredRules"></v-text-field>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit')">
        {{ $t('close') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && submit()">
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {ref} from "@vue/composition-api";
import DatePickerInput from "@/components/DatePickerInput.vue";

export default {
  name: 'AddCouponGroupModal',
  components: {DatePickerInput},
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const name = ref('');


    const submit = function () {
      root.$callAPI('aafb/admin/coupon_group/create/', {
        name: name.value,
      }, function (response) {
        emit('submit', response.body.group.id);
      })
    }

    return {
      requiredRules,
      name,
      submit
    }
  }
}
</script>

<style lang="less">
.add-coupon-group {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .v-card__title, .v-card__text, .v-card__actions {
    width: 100%;
  }

  .v-card__title, .v-card__actions {
    flex: 0 0 auto;
  }

  .v-card__text {
    flex: 1 1 0;
    overflow: auto;
  }
}


</style>
